/**
 * Checks if value is a number
 * @see http://stackoverflow.com/a/1830844/1387163
 *
 * @param value
 * @returns {boolean}
 */
export default function isNumber(value: any): boolean {
  /* (IE doesn't support Number.isNan() and Number.isFinite()) */
  /* eslint-disable-next-line no-restricted-globals */
  return !isNaN(parseFloat(value)) && isFinite(value);
}
